import {
  AddressDto,
  PhoneNumberDto,
  UserDto,
} from '@act/shared/data-transfer-objects';
import { CollapsibleCardHeader, IconLibrary } from '@act/storybook';
import AddressContactContent from './components/AddressContactContent';
import EmailAddressContactCard from './components/EmailAddressContactCard';
import PhoneContactContent from './components/PhoneContactContent';
import { Card, Collapse, Divider } from '@mui/material';
import { useState } from 'react';

export interface CommunicationCardProps {
  member: UserDto;
  addresses: AddressDto[];
  phoneNumbers: PhoneNumberDto[];
  defaultClosed?: boolean;
  onToggle?: () => void;
}

const CommunicationCard = ({
  member,
  addresses,
  phoneNumbers,
  defaultClosed = false,
  onToggle,
}: CommunicationCardProps) => {
  const [open, setOpen] = useState<boolean>(!defaultClosed);
  return (
    <Card>
      <CollapsibleCardHeader
        title={'Communication'}
        avatar={<IconLibrary iconName="Chats" size={24} />}
        collapsible
        onToggle={onToggle}
        open={open}
        setOpen={setOpen}
      />
      <Collapse in={open} timeout="auto" unmountOnExit>
        <PhoneContactContent member={member} phoneNumbers={phoneNumbers} />
        <Divider sx={{ margin: '14px' }} />
        <AddressContactContent member={member} addresses={addresses} />
        <Divider sx={{ margin: '14px' }} />
        <EmailAddressContactCard member={member} />
      </Collapse>
    </Card>
  );
};

export default CommunicationCard;
